<template>
    <div class="order-products-component">
        <vs-popup title="Visualizar Imagem" :active.sync="imagePopup" fullscreen @close="closePopup">
            <div style="max-width: 100%; max-height: 100%;">
                <img :src="imagePopupSrc" width="100%" height="100%" />
            </div>
        </vs-popup>
        <vs-table
            :sst="true"
            ref="table"
            :data="productsList"
            id="tableData"
            @search="searchFilter"
            @sort="sortFilter"
            noDataText="Sem dados disponíveis"
            :max-items="itemsPerPage"
            search
            style="padding-right: 5px !important;"
        >

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center pl-4 mt-2">
                    <div
                        class="
                            p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center
                            text-lg font-medium text-base text-primary border border-solid border-primary
                        "
                        @click="openSidebarToCreate"
                    >
                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span
                            class="ml-2 text-base text-primary"
                        >
                            Adicionar Novo
                        </span>
                    </div>

                    <div
                        v-if="hasErpFeature"
                        class="
                            p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center
                            text-lg font-medium text-base text-primary border border-solid border-primary
                        "
                        @click="openModalToIntegration"
                    >
                      <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                      <span
                          class="ml-2 text-base text-primary"
                      >
                          Sincronizar com ERP
                      </span>
                    </div>

                    <div v-if="canSee('import')" 
                        @click="openModalToImportProduct"
                        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center
                            text-lg font-medium text-base text-primary border border-solid border-primary
                        "
                    >
                      <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                      <span
                          class="ml-2 text-base text-primary"
                      >
                        Subir sua base
                      </span>
                    </div>
                </div>

                <div>
                    <span v-if="hasErpFeature">
                        <select v-if="isIphoneIos" @change="onErpSelected" class="requests">
                            <option value="0">Todos</option>
                            <option v-for="erp in erpList" :key="erp.id" :value="erp.id">{{ erp.corporate_name }}</option>
                            <option value="">Não Vinculados</option>
                        </select>
                        <vs-dropdown v-else>
                            <vs-button
                            class="btn-drop px-3 attendance-span mr-4 erp-drop pl-4"
                            icon="expand_more"
                            icon-after>
                            <span style="font-size:14px;" id="buttonErp">
                                {{ this.selectedErp }}
                            </span>

                            </vs-button>
                        
                            <vs-dropdown-menu class="erp-drop-menu text-center">
                                
                                <vs-dropdown-item class="erp-drop-item" @click="changeErpName('Selecione o ERP', 0)">
                                    <span>Todos</span>
                                </vs-dropdown-item>
                                
                                <vs-dropdown-item v-for="erp in erpList" class="erp-drop-item" @click="changeErpName(erp.corporate_name, erp.id )">
                                    <span>{{ erp.corporate_name }}</span>
                                </vs-dropdown-item>

                                <vs-dropdown-item class="erp-drop-item" @click="changeErpName('Não Vinculados')">
                                    <span>Não Vinculados</span>
                                </vs-dropdown-item>

                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </span>

                    <vs-dropdown
                        vs-trigger-click
                        class="cursor-pointer mr-4"
                    >
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">
                                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                                {{
                                    productsList.length - currentPage * itemsPerPage > 0
                                        ? currentPage * itemsPerPage
                                        : productsList.length
                                }} de {{ queriedItems }}
                            </span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="itemsPerPage=4">
                                <span>4</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=15">
                                <span>15</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>

            <template slot="thead">
                <vs-th class="text-base">
                    Imagem
                </vs-th>
                <vs-th class="text-base" sort-key="name">
                    Nome
                </vs-th>
                <vs-th class="text-base" sort-key="bar_code">
                    Código
                </vs-th>
                <vs-th class="text-base" sort-key="laboratory">
                   Laboratório
                </vs-th>
                <vs-th class="text-base" sort-key="price">
                    Preço
                </vs-th>
                <vs-th class="text-base" sort-key="price">
                    Preço com Desconto
                </vs-th>
                <vs-th class="text-base">
                    Ações
                </vs-th>
            </template>
            
            <template slot-scope="{data}">
                <tbody>
                    <vs-tr 
                        :data="tr" 
                        :key="tr.id"
                        :id="tr.id"
                        v-for="(tr, index) in productsList"
                    >
                        <vs-td :data="tr.image" style="border-top-left-radius: 8px; border-bottom-left-radius: 8px;">
                            <div class="d-flex flex-row items-center justify-evenly">
                              <img
                                  v-if="tr.image !== undefined && tr.image !== '' && tr.image != null"
                                  :src="tr.image"
                                  @click.prevent="expandImage(tr.image)"
                                  style="
                                    max-width: 50px !important;
                                    max-height: 50px !important;
                                  "
                              />

                              <img
                                  v-else
                                  src="@/assets/images/products/product_without_photo.png"
                                  @click.prevent="expandImage(tr.image)"
                                  style="
                                    width: 50px !important;
                                    height: 50px !important;
                                  "
                              >
                            </div>
                        </vs-td>

                        <vs-td :data="tr.name">
                            <div class="text-center">
                                <p>
                                    {{ tr.name }}
                                </p>
                            </div>
                        </vs-td>

                        <vs-td :data="tr.bar_code">
                            <p class="text-center">
                                {{ tr.bar_code }}
                            </p>
                        </vs-td>

                        <vs-td :data="tr.laboratory">
                           <p class="text-center">
                               {{ tr.laboratory ? tr.laboratory : 'Não Informado' }}
                           </p>
                        </vs-td>

                        <vs-td :data="tr.price">
                            <p class="text-center">
                                R$ {{ String(tr.price).replace('.', ',') }}
                            </p>
                        </vs-td>

                        <vs-td :data="tr.discount_price">
                            <p class="text-center">
                                R$ {{ String(tr.discount_price).replace('.', ',') }}
                            </p>
                        </vs-td>

                        <vs-td :id="tr.id" class="text-center" style="border-top-right-radius: 8px; border-bottom-right-radius: 8px">
                            <feather-icon
                              icon="EditIcon"
                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                              @click="openSidebarToUpdate(tr)"
                            />
              
                            <feather-icon
                              icon="TrashIcon"
                              svgClasses="w-5 h-5 hover:text-danger stroke-current"
                              class="ml-2"
                              @click="openModal(tr)"
                            />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>

        <div class="sidebar-products">
            <ProductSidebar
                :isActive="sidebarIsActive"
                @isActiveFalse="closeSidebar()"
                :data="data"
                :context="context"
                :isIphoneIos="isIphoneIos"
            />

            <div>
                <vs-popup title="Remover integração ERP" :active.sync="modalIsActive">
                    <p> Deseja realmente remover o produto <strong>{{data.name}}</strong>?
                    </p> <br>
                    
                    <div class="w-full d-flex justify-content-flex-end">
                      <vs-button color="danger" @click.stop="deleteData">Remover</vs-button>
                    </div>
                </vs-popup>
            </div>
        </div>

        <ErpModal
            :isActive="modalChoiceERP"
            @isActiveFalse="modalChoiceERP=false"
            @listERPs="handleListERPs"
            v-if="hasErpFeature"
        />
        
        <ImportProductModal
            :isActive="modalImportProduct"
            @isActiveFalse="modalImportProduct = false"
        />

        <div class="mt-3 mr-4">
            <vs-pagination
              :max="7"
              :total="totalPages"
              v-model="page"
            />
        </div>
    </div>
</template>

<script>
    import Upload from '@/components/upload/Upload';
    import moduleProduct from "@/store/product/moduleProduct";
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import ErpModal from "./ErpModal.vue";
    import ImportProductModal from "./ImportProductModal.vue";
    import { hasFeature, hasPermission } from '@/utils';
    import moduleSettings from '@/store/settings/moduleSettings';
    import ProductSidebar from './ProductSidebar.vue';

    export default {
        components: {
            VuePerfectScrollbar,
            ErpModal,
            ImportProductModal,
            ProductSidebar,
            Upload
        },
        data() {
            return {
                productsList: [],
                imagePopup: false,
                imagePopupSrc: '',
                isMounted: false,
                selectedErp: 'Selecione o ERP',
                erpId: 0,
                data: {
                    id: undefined,
                    name: '',
                    price: undefined,
                    discount_price: undefined,
                    amount: 0,
                    description: '',
                    category: '',
                    image: '',
                    brand: '',
                    bar_code: '',
                    is_medication: false,
                    active_principle: '',
                    need_prescription: false
                },
                sidebarIsActive: false,
                modalIsActive: false,
                settings: {
                    maxScrollbarLength: 60
                },
                context: '',
                search: '',
                orderBy: {
                    name: 'name',
                    type: 'ASC'
                },
                page: 1,
                itemsPerPage: 4,
                modalChoiceERP: false,
                modalImportProduct: false,
                hasErpFeature: false,
                medicationOptionIsDisabled: false
            }
        },
        computed: {
            totalPages() {
                return this.$store.state.product && this.$store.state.product.products.total_pages
                    ? this.$store.state.product.products.total_pages
                    : 0
            },
            queriedItems() {
                return this.$store.state.product && this.$store.state.product.products.total_items
                    ? this.$store.state.product.products.total_items
                    : 0
            },
            currentPage() {
                if (this.isMounted) {
                  return this.$refs.table.currentx
                }

                return 0
            },
            isIphoneIos() {
                let isIphoneIos = /iPhone|iPad|iPod|Mobile Safari|safari/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent);
                if(isIphoneIos){
                    return true;
                }
                return false;
            },
        },
        methods: {
            onErpSelected(event) {
                const selectedId = parseInt(event.target.value, 10);
                this.selectedErpId = selectedId;
                const selectedErp = this.erpList.find(erp => erp.id === selectedId);
                if (selectedErp) {
                    this.changeErpName(selectedErp.corporate_name, selectedId);
                } else {
                    this.changeErpName('Não Vinculados');
                }
            },
            canSee(action) {
                return hasPermission(`products-${action}`)
            },
            closePopup() {
              this.imagePopup = false
              this.imagePopupSrc = ''
            },
            expandImage(imageUrl) {
                this.imagePopup = true
                this.imagePopupSrc = imageUrl
            },
            async dataLoad() {
                if (!moduleProduct.isRegistered) {
                    this.$store.registerModule('product', moduleProduct)
                    moduleProduct.isRegistered = true
                }

                let response = await this.$store.dispatch("product/fetch", {
                    word: this.search !== '' ? this.search : null,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage,
                    sortName: this.orderBy.name,
                    orderBy: this.orderBy.type,
                    erpId: this.erpId,
                    hideNeedPrescription: this.medicationOptionIsDisabled == 0 ? false : true
                })
                this.productsList = response.data.data.products.items;
            },
            openSidebarToCreate() {
                this.data = {
                    name: '',
                    price: undefined,
                    discount_price: undefined,
                    amount: 0,
                    description: '',
                    category: '',
                    image: '',
                    brand: '',
                    bar_code: '',
                    is_medication: false,
                    active_principle: '',
                    need_prescription: false
                }
                this.context = 'create';
                this.sidebarIsActive = true;
            },
            openSidebarToUpdate(tr) {                
                this.data = tr;
                this.context = 'update'
                this.sidebarIsActive = true;
            },
            closeSidebar() {
                this.sidebarIsActive = false;
                this.dataLoad();
            },
            openModal(tr) {
                this.modalIsActive = true;
                this.data.id = tr.id;
                this.data.name = tr.name;
            },
            async deleteData() {
                const targetId = parseInt(this.data.id);
                await this.$store.dispatch("product/delete", targetId)
                .then((response) => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Sucesso!',
                        text: 'Produto removido com sucesso!'
                    })
                })
                .catch((exception) => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Ocorreu um erro ao deletar o produto!',
                        text: 'Erro ao deleter o produto, por favor nos contate para corrigir-mos!'
                    });
                    console.log(exception);
                });
                await this.dataLoad();
                this.modalIsActive = false;
            },
            async searchFilter(searchQuery) {
                this.page = 1
                this.search = searchQuery;

                await this.dataLoad();
            },
            async sortFilter(sortName) {
                if (sortName !== null) {
                    if (sortName !== this.orderBy.name) {
                        this.orderBy.name = sortName;
                        this.orderBy.type = 'ASC';
                    } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
                        this.orderBy.type = 'DESC';
                    } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
                        this.orderBy.name = 'name';
                        this.orderBy.type = 'ASC';
                    }
                    this.page = 1
                    await this.dataLoad();
                }
            },
            openModalToIntegration() {
                this.modalChoiceERP = true;
            },
            changeErpName(name, erpId) {
                this.selectedErp = name;
                this.erpId = erpId
            },
            handleListERPs(list) {
                this.erpList = list;
            },
            openModalToImportProduct() {
                this.modalImportProduct = true
            },
        },
        watch: {
            hasErpFeature: {
                immediate: true,
                handler(newValue, oldValue) {
                    if (newValue && !oldValue) {
                        this.dataLoad();
                    }
                },
            },
            erpId: {
                handler: 'dataLoad',
                immediate: true
            },
            'page'() {
                this.dataLoad()
            },
            'itemsPerPage'() {
                this.page = 1;
                this.dataLoad()
            },
            'totalPages'() {
                this.page = 1;
            }
        },
        async mounted() {
            this.hasErpFeature = await hasFeature('erps')
            await this.dataLoad();
            this.isMounted = true
        },
        async created() {
            await this.$store.dispatch('settings/fetch');
            this.medicationOptionIsDisabled = this.$store.state.settings.settings.medications_options_is_disabled;
        },
        beforeRouteLeave(to, from, next) {
            if (this.sidebarIsActive) {
                this.sidebarIsActive = false;
                setTimeout( ()=> {
                next();
                }, 2);
            } 
            else if (this.imagePopup) {
                this.imagePopup = false;
                setTimeout( ()=> {
                next();
                }, 2);
            }
            else if (this.modalChoiceERP) {
                this.modalChoiceERP = false;
                setTimeout( ()=> {
                next();
                }, 2);
            }
            else if (this.modalImportProduct) {
                this.modalImportProduct = false;
                setTimeout( ()=> {
                next();
                }, 2);
            }
            else if (this.modalIsActive) {
                this.modalIsActive = false;
                setTimeout( ()=> {
                next();
                }, 2);
            }
            else {
                next();
            }
        },
    }
</script>

<style>
    .order-products-component  * {
        margin: 0;
    }
    .order-products-component html {
        line-height: 1.5;
        letter-spacing: 0.02rem;
    }
    .order-products-component table.vs-table.vs-table--tbody-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
    }
    .order-products-component tbody > tr {
        height: 5em;
        box-shadow: 0 4px 20px 0 rgb(0 0 0 / 5%);
    }
    .order-products-component thead > tr {
        background-color: transparent !important;
    }
    .order-products-component .vs-table-text {
        text-transform: uppercase;
        font-size: 12px;
        text-align: center !important;
        flex-direction: column;
    }
    #input-adjustment, input.input-select.vs-select--input {
        border-radius: 10px;
    }
    .order-products-component input.input-search.vs-table--search-input {
        height: 45px;
    }
    .add-new-data-sidebar.items-no-padding .vs-sidebar--items {
        overflow-y: auto !important;
    }
    .erp-drop {
        background-color: rgba(0, 0, 0, 0) !important;
        border: 1px solid #0491FF;
    }
    .erp-drop span {
        color:#0491FF;
        font-weight: 500;
    }
    .erp-drop i {
        color: #0491FF;
    }
    .erp-drop-menu {
        width: 12rem !important;
    }
    .erp-drop-item {
        padding: .5rem !important;
        font-size: 14px !important;
    }
    .erp-drop-item span {        
        justify-content: center;
        display: flex;
    }
</style>

<style lang="scss" scoped>
    ::v-deep .vs-sidebar {
        z-index: 52010;
        width: 400px;
        max-width: 90vw;
    }
    ::v-deep .vs-sidebar--background {
        z-index: 52010;
    }

    section {
      height: 100% !important;
    }
    .group-input-number {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .scroll-area {
      position: relative;
      margin: auto;
      width: 400px;
      height: 300px;
    }
    .group-div-checkbox {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
</style>

<style lang="scss">
    .order-products-component {

        .vs-pagination--ul {
            width: fit-content!important;
        }

        .vs-pagination--li {
            margin-left: 0.5rem;
            margin-right: 0.5rem;
        }
    }
.requests{
    width: 100px;
    height: 44px;
    border-radius: 5px;
    color: #0491ff;
    border-color: #0491ff;
    background-color: #f8f8f8;
}
</style>